import { RootState } from 'reduxStore/types';

export const getSubcontractorModerationRequestData = (state: RootState) =>
  state?.subcontractorModerationRequest.subcontractorModeration;
